export enum OfferPriceType {
    NETTO = 1,
    BRUTTO = 2
}
